import React, { useEffect } from 'react';
import { ZoomIn, ZoomOut } from 'lucide-react';

export const ZoomBar = ({ zoom, onZoomIn, onZoomOut, onReset, className = '' }) => (
  <div className={`flex items-center gap-1 ${className}`}>
    <button onClick={onZoomOut} disabled={zoom <= 0.5} className="p-1 rounded hover:bg-white/10 text-white/60 hover:text-white disabled:opacity-30 transition-colors" data-testid="zoom-out-btn" title="Zoom out">
      <ZoomOut className="w-4 h-4" />
    </button>
    <button onClick={onReset} className="px-1.5 py-0.5 rounded hover:bg-white/10 text-white/50 text-[10px] font-mono min-w-[40px] text-center" data-testid="zoom-reset-btn" title="Reset zoom">
      {Math.round(zoom * 100)}%
    </button>
    <button onClick={onZoomIn} disabled={zoom >= 3} className="p-1 rounded hover:bg-white/10 text-white/60 hover:text-white disabled:opacity-30 transition-colors" data-testid="zoom-in-btn" title="Zoom in">
      <ZoomIn className="w-4 h-4" />
    </button>
  </div>
);

export const usePinchZoom = (containerRef, zoom, setZoom) => {
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    let startDist = 0;
    let startZoom = 1;
    const getDistance = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    const onTouchStart = (e) => {
      if (e.touches.length === 2) { startDist = getDistance(e.touches); startZoom = zoom; }
    };
    const onTouchMove = (e) => {
      if (e.touches.length === 2) {
        e.preventDefault();
        const dist = getDistance(e.touches);
        const newZoom = Math.max(0.5, Math.min(3, startZoom * (dist / startDist)));
        setZoom(newZoom);
      }
    };
    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    return () => { el.removeEventListener('touchstart', onTouchStart); el.removeEventListener('touchmove', onTouchMove); };
  }, [containerRef, zoom, setZoom]);
};
